export default __webpack_public_path__ + "assets/vimeoShareLink.012b7f70.gif";